module.exports = __webpack_public_path__ + "static/media/pexels-efrain-alonso-3584283.c5a4dcec.jpg";